"use client"

import { Shredder } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShredderIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShredderIcon = component(Icon)({ as: Shredder })
